import { PropOptionRadio, PropOptionSelect } from '@/models'

export const TYPE_PERCENTAGE = 1
export const TYPE_AMOUNT = 2
export const DISCOUNT_TYPE_RENT_5TH = 4

export const FREQUENCY_ONCE = 1
export const FREQUENCY_15 = 2
export const FREQUENCY_30 = 3

export const optionsFrequencyDiscount: PropOptionSelect[] = [
  {
    text: 'Una vez',
    value: FREQUENCY_ONCE
  },
  {
    text: 'Quincenal',
    value: FREQUENCY_15
  },
  {
    text: 'Mensual',
    value: FREQUENCY_30
  }
]

export const optionsDiscountTypes: PropOptionRadio[] = [
  {
    text: 'Por Porcentaje',
    value: TYPE_PERCENTAGE
  },
  {
    text: 'Por Importe',
    value: TYPE_AMOUNT
  }
]

export const getTypeText = (type: number): string => {
  const _t = optionsDiscountTypes.find(op => op.value === type)
  if (_t) {
    return _t.text
  }
  return ''
}
